import murmurhash from 'murmurhash';

export const murmur3Hash = (str: string): string => {
  const hash = murmurhash.v3(str, 0);
  return Math.abs(hash).toString(36).padStart(8, '0').slice(0, 8);
};

export const contentHash = (str: string): string => {
  return murmur3Hash(str);
};
